module.exports = __webpack_public_path__ + "static/img/humanrights_care_homes_banner_mobile.jpg";